"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shift-hours-list-management-page"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h1", [_vm._v("Escalas de trabalho atribuídas")]), _vm._v(" "), _c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary"
    },
    on: {
      click: function click($event) {
        _vm.isModalActive = true;
      }
    }
  }, [_vm._v("\n      Atribuir escala\n    ")])], 1), _vm._v(" "), _c("ShiftAssignmentTable", {
    key: _vm.componentKey,
    attrs: {
      data: _vm.data,
      meta: _vm.meta,
      loading: _vm.isLoading
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      },
      "page-change": _vm.handlePageChange
    }
  }), _vm._v(" "), _c("b-pagination", {
    staticClass: "mt-4",
    attrs: {
      total: _vm.meta.total,
      current: _vm.meta.currentPage,
      "per-page": _vm.meta.perPage,
      "range-before": "2",
      "range-after": "2",
      size: "is-small",
      order: "is-centered"
    },
    on: {
      "update:current": function updateCurrent($event) {
        return _vm.$set(_vm.meta, "currentPage", $event);
      },
      change: _vm.handlePageChange
    }
  }), _vm._v(" "), _c("ShiftAssignmentModal", {
    attrs: {
      "is-modal-active": _vm.isModalActive
    },
    on: {
      onCreate: _vm.fetchShiftAssignments,
      onClose: function onClose($event) {
        _vm.isModalActive = false;
      }
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;